import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.04167 1.78869L5.06031 1.78644L5.08924 1.78516L5.11335 1.78612L5.15385 1.79158L5.18953 1.80123L5.22521 1.81537L5.25671 1.83208L5.29013 1.85587L5.31649 1.87933L7.08435 3.64719C7.142 3.70504 7.17546 3.78265 7.17796 3.86428C7.18045 3.94591 7.15178 4.02542 7.09777 4.08667C7.04376 4.14793 6.96846 4.18633 6.88716 4.19407C6.80586 4.20181 6.72467 4.17832 6.66006 4.12837L6.62985 4.10169L5.41067 2.88283V7.8923C5.41058 7.97422 5.37921 8.05302 5.32297 8.1126C5.26673 8.17217 5.18986 8.20802 5.10808 8.21282C5.02629 8.21762 4.94576 8.19101 4.88294 8.13843C4.82011 8.08585 4.77974 8.01126 4.77006 7.92991L4.76781 7.8923V2.88283L3.54863 4.10169C3.49329 4.15703 3.41965 4.19028 3.34153 4.19519C3.26342 4.2001 3.18619 4.17634 3.12435 4.12837L3.09413 4.10169C3.03879 4.04634 3.00555 3.9727 3.00063 3.89459C2.99572 3.81647 3.01948 3.73925 3.06746 3.67741L3.09413 3.64719L4.86199 1.87933C4.87321 1.86807 4.88524 1.85765 4.89799 1.84816L4.93335 1.82533L4.96999 1.80798L5.00374 1.79673L5.04167 1.78869Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SortDescIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "sort-desc",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})